<template>
  <div class="absolute fill-height events-page">
    <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
      {{ ok_text }}
      <v-btn color="white" flat @click="ok_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
      {{ error_text }}
      <v-btn color="white" flat @click="error_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <v-dialog
            v-model="dialogRemove"
            persistent
            max-width="700px"
            transition="dialog-transition"
            v-if="dialogRemove"
          >
            <v-card class="no__padding">
              <v-card-title>
                <h2>Smazání produktu</h2>
              </v-card-title>
              <v-card-text class="pt-0 pb-2">
                Opravu chcete smazat <strong>{{ removeItem.nazev }}</strong> z produktů?
              </v-card-text>
              <v-divider class="mt-2 mb-2"></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red elevation-0" dark @click="remove" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
                <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <div class="custom-scrollbar" v-if="!editMode">
            <v-card color="grey lighten-4" class="pt-3 pb-3 pl-0 pr-0 no__radius" :class="{'pr-3 pl-3': $vuetify.breakpoint.smAndUp}">
              <v-layout row wrap align-center>
                <v-flex xs12 sm6>
                  <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
                    <v-icon slot="divider">chevron_right</v-icon>
                    <v-breadcrumbs-item>
                      <v-btn color="blue" outline @click="gotoall" class="ma-0">Produkty</v-btn>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item>
                      {{item.nazev}}
                    </v-breadcrumbs-item>
                  </v-breadcrumbs>
                </v-flex>
                <v-flex xs12 sm6 class="text-sm-right">
                  <div class="px-2">
                    <v-btn color="primary" v-if="!editMode" @click="editClick" class="elevation-0" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
                    <v-btn color="primary lighten-1" v-if="!editMode && item.typ_produktu != 'staticky' && !item.pevna_cena" @click="refreshPrice" class="elevation-0" :class="{'v-btn--block':$vuetify.breakpoint.xs}" :loading="refreshingPrice"><v-icon small class="mr-2">refresh</v-icon>Aktualizovat cenu</v-btn>
                    <v-menu offset-y left bottom>
                      <v-btn color="primary" flat slot="activator"><v-icon>more_vert</v-icon></v-btn>
                      <v-list>
                        <v-list-tile>
                          <v-btn color="red" @click="removeClick" flat><v-icon small class="mr-2">delete</v-icon>Smazat</v-btn>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </div>
                </v-flex>
              </v-layout>

              <v-card-text>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <h2>{{item.nazev}}</h2>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-switch :label="item.aktivni ? 'Aktivní produkt' : 'Neaktivní produkt'" v-model="item.aktivni" color="green" hide-details readonly></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-4">
                  <v-flex xs12 sm6 md6>
                    <p class="grey--text caption mb-1">Kategorie:</p> <strong v-if="item.kategorie !== null">{{item.kategorie.nazev}}</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Materiál:</p> <strong v-if="item.material != null">{{item.material.nazev}}</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md6>
                    <p class="grey--text caption mb-1">Krátký popis:</p>
                    <p class="ma-0 pr-4"><strong>{{item.kratky_popis}}</strong></p>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <p class="grey--text caption mb-1">Detailní popis:</p>
                    <p class="ma-0 pr-4"><strong>{{item.detailni_popis}}</strong></p>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Obecné informace</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Ryzost:</p> <strong v-if="item.ryzost">{{item.ryzost}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Váha:</p> <strong v-if="item.vaha">{{item.vaha}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Váha v g:</p> <strong v-if="item.vaha_g">{{item.vaha_g}} g</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Rozměry:</p> <strong v-if="item.rozmery">{{item.rozmery}}</strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Země původu:</p> <strong v-if="item.zeme_puvodu !== null">{{item.zeme_puvodu.nazev}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Výrobce:</p> <strong v-if="item.vyrobce !== null">{{item.vyrobce.nazev}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Rok ražby:</p> <strong v-if="item.rok_razby">{{item.rok_razby}}</strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Motiv:</p> <strong v-if="item.motiv">{{item.motiv}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Nominální hodnota:</p> <strong v-if="item.nominalni_hodnota">{{item.nominalni_hodnota}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Balení:</p> <strong v-if="item.baleni">{{item.baleni}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Minimální stav zásoby:</p> <strong v-if="item.min_stav_zasoby">{{item.min_stav_zasoby}} ks</strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <!--<v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Aktuální prodejní cena:</p> <strong v-if="item.aktualni_prodejni_cena !== null">{{item.aktualni_prodejni_cena}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Aktuální výkupní cena:</p> <strong v-if="item.aktualni_vykupni_cena !== null">{{item.aktualni_vykupni_cena}}</strong><strong v-else>--</strong>
                  </v-flex>-->
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Prodejnost:</p> <strong v-if="item.prodejnost">{{item.prodejnost}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Výše zpětného bonusu:</p> <strong v-if="item.vyse_zpetneho_bonusu !== null">{{item.vyse_zpetneho_bonusu}} Kč</strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Povolit generování ceny:</p> <strong v-if="item.povolit_generovani_ceny">Ano</strong><strong v-else>Ne</strong>
                    <strong v-else>Ne</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Možno předat jako dárek:</p> <strong v-if="item.mozne_jako_darek">Ano</strong><strong v-else>Ne</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">ID produktu u partnera:</p> <strong v-if="item.id_produktu_partnera !== null">{{item.id_produktu_partnera}}</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">URL:</p> <strong v-if="item.url !== null"><a :href="item.url" target="_blank">{{item.url}}</a></strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Informace pro výpočty:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Obchodní přirážka:</p> <strong v-if="item.obchodni_prirazka !== null">{{item.obchodni_prirazka}} %</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Náklady na výrobu:</p> <strong v-if="item.naklady_vyroba !== null">{{item.naklady_vyroba}} &euro;</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Výkupní koeficient (abs. hodnota):</p> <strong v-if="item.vykupni_koeficient !== null">{{item.vykupni_koeficient}} Kč</strong><strong v-else>--</strong>
                  </v-flex>
                  <!-- TODO doplnit % -->
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Náklady na dopravnu %:</p> <strong v-if="item.vykupni_koeficient !== null">{{item.vykupni_koeficient}} %</strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Zvláštní režim:</p>
                    <strong v-if="item.zvlastni_rezim == 'neni'">Bez zvláštního režimu</strong>
                    <strong v-else-if="item.zvlastni_rezim == 'par_90'">Zvláštní režim par. 90</strong>
                    <strong v-else>Zvláštní režim par. 92</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.zvlastni_rezim != 'par_92'">
                    <p class="grey--text caption mb-1">Sazba DPH:</p>
                    <strong v-if="item.sazba_dph!=null">{{item.sazba_dph.nazev}}</strong>
                    <strong v-else>--</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Kredity za jednorázový nákup:</p> <strong v-if="item.kredity_jednorazovy_nakup">{{item.kredity_jednorazovy_nakup}} kr.</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Počet kreditů při spoření:</p> <strong v-if="item.kredity_sporeni">{{item.kredity_sporeni}} kr.</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Typ produktu:</p>
                    <strong v-if="item.typ_produktu == 'slitek'">Slitek</strong>
                    <strong v-if="item.typ_produktu == 'mince'">Mince</strong>
                    <strong v-else-if="item.typ_produktu == 'staticky'">Statický</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Produkt se sériovým číslem:</p> <strong v-if="item.vyzadovat_seriove_cislo">Ano</strong><strong v-else>Ne</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Nabízet pro spoření:</p> <strong v-if="item.nabizet_sporeni">Ano</strong><strong v-else>--</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Pevná cena produktu (pro akční nabídky):</p> <strong v-if="item.pevna_cena">Ano</strong><strong v-else>Ne</strong>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Dodavatelé:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <p class="" v-if="item.dodavatele.length > 0"><v-chip color="blue lighten-4" v-for="(d, i) in item.dodavatele" :key="'dodavatel-'+i.toString()">{{d.nazev}}</v-chip></p>
                    <p class="grey--text" v-else><strong>Nejsou přiřazeni žádní dodavatelé.</strong></p>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Náhradní produkty:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <p class="" v-if="item.nahradni_produkty.length > 0"><v-chip color="blue lighten-4" v-for="(n, i) in item.nahradni_produkty" :key="'dodavatel-'+i.toString()">{{n.nazev}}</v-chip></p>
                    <p class="grey--text" v-else><strong>--</strong></p>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Informace pro e-shop:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">TOP produkt:</p> <strong v-if="item.top_produkt">Ano</strong><strong v-else>Ne</strong>
                    <strong v-else>Ne</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Uvádět prodejní cenu za 1 g:</p> <strong v-if="item.uvadet_prodejni_cenu">Ano</strong><strong v-else>Ne</strong>
                    <strong v-else>Ne</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Uvádět výkupní cenu za 1 g:</p> <strong v-if="item.uvadet_vykupni_cenu">Ano</strong><strong v-else>Ne</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="item.typ_produktu!='staticky'">
                    <p class="grey--text caption mb-1">Uvádět výkupní cenu:</p> <strong v-if="!item.skryt_eshop_vykup_cena">Ano</strong><strong v-else>Na dotaz</strong>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Dostupnost:</p> <strong v-if="item.dostupnost !== null">{{item.dostupnost.popis}}</strong><strong v-else>--</strong>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Obrázky:</h3>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-2">
                  <v-flex xs12>
                    <v-card class="no__radius pt-3 px-2 pb-2">
                      <v-layout row wrap>
                        <v-flex shrink class="px-2" v-for="soubor in item.obrazky">
                          <img :src="$imagesBaseUrl+soubor.s3_nazev" :alt="soubor.nazev" class="admin-img">
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Aktuální ceny:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <div class="white">
                      <v-data-table
                        :headers="cenyHeaders"
                        :items="item.aktualni_ceny"
                        hide-controls
                      >
                      <template slot="items" slot-scope="props">
                        <td>{{props.item.mena.zkratka}}</td>
                        <td class="text-xs-right"><span v-if="props.item.cena_url!=null&&props.item.cena_url>0">{{props.item.cena_url | formatMoney}} €</span></td>
                        <td class="text-xs-right">{{props.item.prodejni_cena_bez_dph | formatMoney}} {{props.item.mena.zkratka}}</td>
                        <td class="text-xs-right">{{props.item.prodejni_cena_dph | formatMoney}} {{props.item.mena.zkratka}}</td>
                        <td class="text-xs-right">{{props.item.prodejni_cena | formatMoney}} {{props.item.mena.zkratka}}</td>
                        <td class="text-xs-right"><span v-if="props.item.vykupni_cena!=null">{{props.item.vykupni_cena | formatMoney}} {{props.item.mena.zkratka}}</span></td>
                      </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="item.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Vývoj cen:</h3>
                  </v-flex>
                </v-layout>

                <v-card class="white no__radius mt-4" v-if="chartLoaded" v-for="(chart, n) in charts" :key="'price-chart-' + n.toString()">
                  <v-card-text>
                    <apexchart width="100%" height="300" type="line" :options="chart.options" :series="chart.series"></apexchart>
                  </v-card-text>
                </v-card>

              </v-card-text>
            </v-card>

            <!--<v-card-actions class="mt-4">
              <v-spacer></v-spacer>

            </v-card-actions>-->
          </div>

          <div class="custom-scrollbar" v-else>

            <v-card color="grey lighten-4" class="pt-3 pr-0 pl-0 pb-1 no__radius" :class="{'pr-3 pl-3': $vuetify.breakpoint.smAndUp}">
              <v-card-text>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <h2>Detail produktu</h2>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-switch :label="updateItem.aktivni ? 'Aktivní produkt' : 'Neaktivní produkt'" v-model="updateItem.aktivni" color="green" hide-details></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Název" v-model="updateItem.nazev" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <kategorie v-model="updateItem.kategorie_id" @changed="(v) => { this.updateItem.kategorie = v }"></kategorie>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <material v-model="updateItem.material_id" @changed="(v) => { this.updateItem.material = v }"></material>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md6>
                    <v-textarea
                      class="mx-2"
                      label="Krátký popis"
                      v-model="updateItem.kratky_popis"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-textarea
                      class="mx-2"
                      label="Detailní popis"
                      v-model="updateItem.detailni_popis"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Obecné informace</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Ryzost" v-model="updateItem.ryzost" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Váha" v-model="updateItem.vaha" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Váha v g" v-model="updateItem.vaha_g" class="mx-2" suffix="g" type="number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Rozměry" v-model="updateItem.rozmery" class="mx-2"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <zeme v-model="updateItem.zeme_puvodu_id" @changed="(v) => { this.updateItem.zeme_puvodu = v }"></zeme>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <vyrobci v-model="updateItem.vyrobce_id" @changed="(v) => { this.updateItem.vyrobce = v }"></vyrobci>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Rok ražby" v-model="updateItem.rok_razby" class="mx-2"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Motiv" v-model="updateItem.motiv" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Nominální hodnota" v-model="updateItem.nominalni_hodnota" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Balení" v-model="updateItem.baleni" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Minimální stav zásoby" v-model="updateItem.min_stav_zasoby" class="mx-2" suffix="ks"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Prodejnost" v-model="updateItem.prodejnost" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Výše zpětného bonusu" v-model="updateItem.vyse_zpetneho_bonusu" class="mx-2" suffix="Kč"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-checkbox
                      label="Povolit generování ceny"
                      class="mx-2"
                      v-model="updateItem.povolit_generovani_ceny"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-checkbox
                      label="Možno předat jako dárek:"
                      class="mx-2"
                      v-model="updateItem.mozne_jako_darek"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="ID produktu u partnera" v-model="updateItem.id_produktu_partnera" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="URL" v-model="updateItem.url" class="mx-2"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Informace pro výpočty:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Obchodní přirážka" v-model="updateItem.obchodni_prirazka" class="mx-2" suffix="%"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Náklady na výrobu" v-model="updateItem.naklady_vyroba" class="mx-2" suffix="€"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Výkupní koeficient (abs. hodnota)" v-model="updateItem.vykupni_koeficient" class="mx-2" suffix="Kč"></v-text-field>
                  </v-flex>
                  <!-- TODO doplnit % -->
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Náklady na dopravu %" v-model="updateItem.vykupni_koeficient" class="mx-2" suffix="Kč"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12 sm9 md6>
                    <v-radio-group v-model="updateItem.zvlastni_rezim" row>
                      <v-radio label="Bez zvláštního režimu" value="neni" class="mx-1"></v-radio>
                      <v-radio label="Zvláštní režim par. 90" value="par_90" class="mx-1"></v-radio>
                      <v-radio label="Zvláštní režim par 92" value="par_92" class="mx-1"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <!--<v-text-field label="Sazba DPH" v-model="updateItem.sazba_dph" class="mx-2"></v-text-field>-->
                    <sazba-dph v-model="updateItem.sazba_dph_id" @changed="(v) => { this.updateItem.sazba_dph = v }"></sazba-dph>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Kredity za jednorázový nákup" v-model="updateItem.kredity_jednorazovy_nakup" class="mx-2" suffix="kr."></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-text-field label="Počet kreditů při spoření" v-model="updateItem.kredity_sporeni" class="mx-2" suffix="kr."></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-radio-group v-model="updateItem.typ_produktu" row class="mx-2" :disabled="updateItem.typ_produktu=='staticky'">
                      <v-radio label="Mince" value="mince"></v-radio>
                      <v-radio label="Slitek" value="slitek"></v-radio>
                      <v-radio label="Statický" value="staticky" v-if="updateItem.typ_produktu=='staticky'"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-checkbox label="Produkt se sériovým číslem" v-model="updateItem.vyzadovat_seriove_cislo"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-checkbox
                      label="Nabízet pro spoření"
                      class="mx-2"
                      v-model="updateItem.nabizet_sporeni"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-checkbox
                      label="Pevná cena produktu (pro akční nabídky)"
                      class="mx-2"
                      v-model="updateItem.pevna_cena"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Dodavatelé:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <dodavateleselect v-model="updateItem.dodavatele_id"></dodavateleselect>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <h3>Náhradní produkty:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu!='staticky'">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-chip color="blue lighten-4" v-for="(n, i) in updateItem.nahradni_produkty" :key="'edit-dodavatel-'+i.toString()" @input="deleteNahradniProdukt(n)" close>{{n.nazev}}</v-chip>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <productsearch v-model="nahradni_produkt" @changed="nahradniProdukt" class="mx-2" ref="nahradniProductSearch" :material="updateItem.material_id" :vaha="updateItem.vaha_g" :except="[updateItem.id]" :typ_produktu="updateItem.typ_produktu" loadOnMounted></productsearch>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Informace pro e-shop:</h3>
                  </v-flex>
                </v-layout>
                <!--<v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Aktuální prodejní cena" v-model="updateItem.aktualni_prodejni_cena" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Aktuální výkupní cena" v-model="updateItem.aktualni_vykupni_cena" class="mx-2"></v-text-field>
                  </v-flex><
                </v-layout>-->
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <v-checkbox
                      label="TOP produkt"
                      class="mx-2"
                      v-model="updateItem.top_produkt"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-checkbox
                      label="Uvádět prodejní cenu za 1 g"
                      class="mx-2"
                      v-model="updateItem.uvadet_prodejni_cenu"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-checkbox
                      label="Uvádět výkupní cenu za 1 g"
                      class="mx-2"
                      v-model="updateItem.uvadet_vykupni_cenu"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3 v-if="updateItem.typ_produktu!='staticky'">
                    <v-checkbox
                      label="Výkupní cena 'na dotaz'"
                      class="mx-2"
                      v-model="updateItem.skryt_eshop_vykup_cena"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <dostupnost v-model="updateItem.dostupnost_id" @changed="(v) => { this.updateItem.dostupnost = v }"></dostupnost>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5" v-if="updateItem.typ_produktu=='staticky' || updateItem.pevna_cena">
                  <v-flex xs12>
                    <h3>Ceny:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3" v-if="updateItem.typ_produktu=='staticky' || updateItem.pevna_cena">
                  <v-flex xs12>
                    <div class="white">
                      <v-data-table
                        :headers="cenyEditHeaders"
                        :items="updateItem.aktualni_ceny"
                        hide-controls
                      >
                      <template slot="items" slot-scope="props">
                        <td>{{props.item.mena.zkratka}}</td>
                        <td class="text-xs-right" style="min-width: 190px">
                            <v-text-field
                            label="Cena bez DPH"
                            v-model="props.item.prodejni_cena_bez_dph"
                            :suffix="props.item.mena.zkratka"
                            type="number"
                            @input="(v) => { if (props.item.sazba_dph != null) { props.item.prodejni_cena = (parseFloat(v) * (1 + props.item.sazba_dph.sazba_procento/100.0)).toFixed(2); } }"
                          ></v-text-field>
                        </td>
                        <td class="text-xs-right" style="min-width: 140px">
                          <sazbadph v-model="props.item.sazba_dph_id" @changed="(v) => { props.item.sazba_dph = v; if (props.item.prodejni_cena_bez_dph != null && props.item.prodejni_cena_bez_dph.length > 0) { props.item.prodejni_cena_bez_dph = (parseFloat(props.item.prodejni_cena_bez_dph) - (parseFloat(props.item.prodejni_cena_bez_dph) - (parseFloat(props.item.prodejni_cena_bez_dph) / (1 + props.item.sazba_dph.sazba_procento/100.0)))).toFixed(2); } }"></sazbadph>
                        </td>
                        <td class="text-xs-right" style="min-width: 190px">
                          <v-text-field
                            label="Cena s DPH"
                            v-model="props.item.prodejni_cena"
                            :suffix="props.item.mena.zkratka"
                            type="number"
                            @input="(v) => { if (props.item.sazba_dph != null) { props.item.prodejni_cena_bez_dph = (parseFloat(v) - (parseFloat(v) - (parseFloat(v) / (1 + props.item.sazba_dph.sazba_procento/100.0)))).toFixed(2); } }"
                          ></v-text-field>
                        </td>
                      </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Obrázky:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-1">
                  <v-flex xs12>
                    <vue-dropzone :options="dropzoneOptions" :id="'dropzone'" :useCustomSlot="true" style="min-height: 120px;">
                      <v-card class="pa-0 no__radius elevation-1" color="white">
                        <v-card-text class="pt-3 px-2 text-xs-left">
                          <div>
                             <!-- <div v-for="element in myArray" :key="element.id">{{element.name}}</div> -->
                             <v-layout row wrap>
                               <draggable v-model="updateItem.obrazky" group="people" @start="drag=true" @end="drag=false" class="d-flex" style="width: 100%;flex-wrap:wrap;">
                                 <v-flex xs12 sm3 class="px-2 mb-2" v-for="soubor in updateItem.obrazky">
                                   <v-card class="no__radius pt-0 px-2 pb-3" color="grey lighten-3">
                                     <v-card-title class="py-2 px-0 justify-end">
                                       <v-btn color="red" flat class="ma-0" @click="removeFile(soubor)"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
                                     </v-card-title>
                                     <v-card-text class="pa-0">
                                       <img :src="$imagesBaseUrl+soubor.s3_nazev" :alt="soubor.nazev" class="edit-img">
                                     </v-card-text>
                                     <v-card-actions class="pa-0 mt-2">
                                       <p class="mb-0 caption word-break">{{soubor.nazev}}</p>
                                     </v-card-actions>
                                   </v-card>
                                 </v-flex>
                               </draggable>
                             </v-layout>
                             <!-- <template>
                               <v-chip close class="pointer" color="blue" light @input="removeFile(soubor)"><a :href="$imagesBaseUrl+soubor.s3_nazev" target="_blank" class="tm1 white--text">{{soubor.nazev}}</a></v-chip>
                             </template> -->
                          </div>
                          <p class="pt-5 pb-4 text-xs-center">Nahrajte přetažením souboru z&nbsp;počítače</p>
                        </v-card-text>
                      </v-card>
                    </vue-dropzone>
                    <div hidden id="dropzone-preview"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card-actions class="mt-4">
              <v-btn color="primary" class="elevation-0" @click="edit" :loading="updating"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
              <v-btn color="red" flat @click="editMode=false"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
            </v-card-actions>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import draggable from 'vuedraggable'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      // Item variables start
      editMode: false,
      item: {},
      dialogUpdate: false,
      updateItem: {},
      dialogRemove: false,
      removeItem: {},
      updating: false,
      removing: false,
      // Item variables end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      cenyHeaders: [
        { text: 'Měna', value: 'mena.nazev', sortable: false },
        { text: 'Cena z URL', value: 'cena_url', sortable: false, align: 'right' },
        { text: 'Prodejní cena bez DPH', value: 'prodejni_cena_bez_dph', sortable: false, align: 'right' },
        { text: 'DPH', value: 'prodejni_cena_dph', sortable: false, align: 'right' },
        { text: 'Prodejní cena s DPH', value: 'prodejni_cena', sortable: false, align: 'right' },
        { text: 'Výkupní cena', value: 'vykupni_cena', sortable: false, align: 'right' },
      ],
      cenyEditHeaders: [
        { text: 'Měna', value: 'mena.nazev', sortable: false },
        { text: 'Prodejní cena bez DPH', value: 'prodejni_cena_bez_dph', sortable: false, align: 'right' },
        { text: 'Sazba DPH', value: 'prodejni_cena_dph', sortable: false, align: 'right' },
        { text: 'Prodejní cena s DPH', value: 'prodejni_cena', sortable: false, align: 'right' }
      ],
      itemsChips: [],
      value: [],
      nahradni_produkt: null,
      charts: [],
      chartLoaded: false,
      refreshingPrice: false,
      dropzoneOptions: null
    }
  },
  props: {
    id: String,
    editProduct: Boolean
  },
  created () {
    var $this = this;
    this.dropzoneOptions = {
      url: window.API.$api_url+"uploader/file",
      clickable: false,
      autoProcessQueue: true,
      uploadMultiple: false,
      parallelUploads: 1,
      addRemoveLinks: true,
      previewsContainer: "#dropzone-preview",
      headers: {
        "AuthToken": window.api.$cookies.get("cc_com_token")
      },
      init: function() {
        this.on("addedfile", function(a, b, c) {
          $this.uploading = true;
        }.bind(this));
        this.on("success", function(a, b, c) {
          if (b.uploaded) {
            $this.updateItem.obrazky.push({
              id: b.id,
              nazev: a.name,
              s3_nazev: b.s3_name
            });
          }
        }.bind(this));
      }
    };
  },
  mounted: function() {
    this.load();
  },
  methods: {
    gotoall () {
      this.$router.push({ path: "/produkty" });
    },
    load (f) {
      window.api.get("produkty/" + this.$props.id).then((_body) => {
        this.item = _body;
        this.loading = false;
        this.loadVyvojCen();
        if (this.$props.editProduct) {
          this.updateItem = window.th.copy(this.item);
          this.editMode = true;
        }
        if (typeof f === "function")
          f();
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    editClick () {
      this.updateItem = window.th.copy(this.item);
      this.editMode = true;
    },
    edit () {
      this.updating = true;
      window.api.put("produkty/" + this.$props.id, this.updateItem).then((_body) => {
        if (_body.updated) {
          this.load();
          this.editMode = false;
        }
        if (this.editProduct)
          this.gotoall();
        this.updating = false;
      }).catch((err) => {
        console.log(err);
        this.updating = false;
      });
    },
    removeClick () {
      this.removeItem = window.th.copy(this.item);
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.api.delete("produkty/" + this.$props.id).then((_body) => {
        if (_body.deleted) {
          this.$router.push({ path: "/produkty" })
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    nahradniProdukt (v) {
      if (v == null)
        return;
      if (this.updateItem.nahradni_produkty_id.indexOf(v.id) == -1) {
        this.updateItem.nahradni_produkty.push(v);
        this.updateItem.nahradni_produkty_id.push(v.id);
      }
      this.$refs.nahradniProductSearch.clearSelectedItem();
    },
    deleteNahradniProdukt (v) {
      this.updateItem.nahradni_produkty.splice(this.updateItem.nahradni_produkty.indexOf(v), 1);
      this.updateItem.nahradni_produkty_id.splice(this.updateItem.nahradni_produkty_id.indexOf(v.id), 1);
    },
    loadVyvojCen () {
      window.api.get("produkty/" + this.$props.id + "/vyvoj-cen").then((_body) => {
        this.charts = [];
        var series = [];
        for (var $i = 0; $i < _body.prodejni_ceny.length; $i++) {
          var _zkratka = _body.prodejni_ceny[$i].mena.zkratka;
          this.charts.push({
            options: {
              title: {
                text: "Prodej " + _body.prodejni_ceny[$i].mena.identifikator,
                align: "center",
                style: {
                  fontSize:  '22px'
                },
              },
              chart: {
                id: 'produkt-price-prodej-' + _body.prodejni_ceny[$i].mena.identifikator
              },
              xaxis: {
                type: "datetime",
                labels: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y HH:mm");
                  }
                }
              },
              yaxis: {
                min: _body.prodejni_ceny[$i].min,
                max: _body.prodejni_ceny[$i].max,
                labels: {
                  formatter: function (value) {
                    return value.toFixed(2) + " " + this;
                  }.bind(_zkratka)
                },
              },
              tooltip: {
                x: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y HH:mm");
                  }
                }
              }
            },
            series: [{
              name: "Prodej " + _body.prodejni_ceny[$i].mena.identifikator,
              data: _body.prodejni_ceny[$i].ceny.map((e) => { 
                return [
                  e.cas,
                  e.cena
                ];
              })
            }]
          });
        }
        for (var $i = 0; $i < _body.vykupni_ceny.length; $i++) {
          var _zkratka = _body.prodejni_ceny[$i].mena.zkratka;
          this.charts.push({
            options: {
              title: {
                text: "Výkup " + _body.vykupni_ceny[$i].mena.identifikator,
                align: "center",
                style: {
                  fontSize:  '22px'
                },
              },
              chart: {
                id: 'produkt-price-vykup-' + _body.prodejni_ceny[$i].mena.identifikator
              },
              xaxis: {
                type: "datetime",
                labels: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y HH:mm");
                  }
                }
              },
              yaxis: {
                min: _body.vykupni_ceny[$i].min,
                max: _body.vykupni_ceny[$i].max,
                labels: {
                  formatter: function (value) {
                    return value.toFixed(2) + " " + this;
                  }.bind(_zkratka)
                },
              },
              tooltip: {
                x: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y HH:mm");
                  }
                }
              }
            },
            series: [{
              name: "Výkup " + _body.vykupni_ceny[$i].mena.identifikator,
              data: _body.vykupni_ceny[$i].ceny.map((e) => { 
                return [
                  e.cas,
                  e.cena
                ];
              })
            }]
          });
        }
        //this.priceChart.series = series;
        this.chartLoaded = true;
      }).catch((err) => {
        console.log(err);
      });
    },
    refreshPrice () {
      this.refreshingPrice = true;
      window.api.get("produkty/" + this.$props.id + "/aktualizovat-cenu").then((_body) => {
        if (_body.success) {
          this.load(() => {
            this.refreshingPrice = false;
            this.ok("Ceny byly aktualizována");
          });
        }
        else {
          this.refreshingPrice = false;
          this.error("Chyba při aktualizaci ceny.");
        }
      }).catch((err) => {
        console.log(err);
        this.refreshingPrice = false;
        this.error("Chyba při aktualizaci ceny.");
      });
    },
    removeFile: function(item) {
      this.updateItem.obrazky.splice(this.updateItem.obrazky.indexOf(item), 1);
    },
  },
  components: {
    vueDropzone: vue2Dropzone, draggable
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Produkty/ProduktDetail.vue